import * as React from 'react';
import { Layout } from '../Layout';
import * as styles from './Basic.css';

export interface IBasicProps {
  name: React.ReactNode;
  price: React.ReactNode;
  callback: React.ReactNode;
  labels: React.ReactNode;
  call: React.ReactNode;
  flatViewOrder: React.ReactNode;
}

export const Basic: React.FC<IBasicProps> = props => {
  const { name, price, callback, labels, call, flatViewOrder } = props;

  return (
    <div className={styles['basic']}>
      <Layout>
        {labels}
        {name}
        {price}
        <div className={styles['controls']}>
          {call}
          {flatViewOrder}
          {callback}
        </div>
      </Layout>
    </div>
  );
};
